(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-joke-ticker"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-ticker-element')) {
    class CustomTickerElement extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        const tickerList = this.querySelector('.custom-ticker__inner');
        const tickerDirect = parseInt(this.dataset.direction);
        const tickerListWidth = tickerList.offsetWidth;
        const cloneEl = tickerList.cloneNode(true);
        cloneEl.classList.add('cloned');
        this.append(cloneEl);

        let start = window.performance.now();
        let progress;
        let translateX;
        const duration = parseInt(this.dataset.duration, 10) || 21000;
        let mouseEntered = false;

        this.parentElement.addEventListener('mouseenter', () => {
          mouseEntered = true;
        });
        this.parentElement.addEventListener('mouseleave', () => {
          mouseEntered = false;
        });

        // Respect reduced-motion preference: leave the ticker static.
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        const tick = (now) => {
          if (mouseEntered === false && !document.hidden) {
            progress = (now - start) / duration;
            if (progress > 1) {
              progress %= -1;
              start = now;
            }
            if (tickerDirect == 1) {
              translateX = tickerListWidth * progress - tickerListWidth;
              cloneEl.style.transform = `translate3d(${translateX}px, 0, 0)`;
              tickerList.style.transform = `translate3d(${translateX}px, 0, 0)`;
            } else {
              translateX = tickerListWidth * progress;
              tickerList.style.transform = `translate3d(-${translateX}px, 0, 0)`;
              cloneEl.style.transform = `translate3d(-${translateX}px, 0, 0)`;
            }
          }
          window.requestAnimationFrame(tick);
        };
        tick(window.performance.now());
      }
    }
    customElements.define('custom-ticker-element', CustomTickerElement);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-ticker"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-ticker-element')) {
  class CustomTickerElement extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const tickerList = this.querySelector('.custom-ticker__inner');
      const tickerDirect = parseInt(this.dataset.direction);
      const tickerListWidth = tickerList.offsetWidth;
      const cloneEl = tickerList.cloneNode(true);
      cloneEl.classList.add('cloned');
      this.append(cloneEl);

      let start = window.performance.now();
      let progress;
      let translateX;
      const duration = parseInt(this.dataset.duration, 10) || 21000;
      let mouseEntered = false;

      this.parentElement.addEventListener('mouseenter', () => {
        mouseEntered = true;
      });
      this.parentElement.addEventListener('mouseleave', () => {
        mouseEntered = false;
      });

      // Respect reduced-motion preference: leave the ticker static.
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const tick = (now) => {
        if (mouseEntered === false && !document.hidden) {
          progress = (now - start) / duration;
          if (progress > 1) {
            progress %= -1;
            start = now;
          }
          if (tickerDirect == 1) {
            translateX = tickerListWidth * progress - tickerListWidth;
            cloneEl.style.transform = `translate3d(${translateX}px, 0, 0)`;
            tickerList.style.transform = `translate3d(${translateX}px, 0, 0)`;
          } else {
            translateX = tickerListWidth * progress;
            tickerList.style.transform = `translate3d(-${translateX}px, 0, 0)`;
            cloneEl.style.transform = `translate3d(-${translateX}px, 0, 0)`;
          }
        }
        window.requestAnimationFrame(tick);
      };
      tick(window.performance.now());
    }
  }
  customElements.define('custom-ticker-element', CustomTickerElement);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window
        .matchMedia('(max-width: 990px)')
        .addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      const headerHeight = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);

      if (window.innerWidth < 990 || this.headerIsAlwaysSticky) {
        this.updateHeaderBottomPosition();
      } else {
        document.documentElement.style.removeProperty('--header-bottom-position');
      }
    }

    updateHeaderBottomPosition() {
      const value = this.headerIsAlwaysSticky ? '20rem' : '0px';
      document.documentElement.style.setProperty('--header-bottom-position', value);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;

      if (window.innerWidth < 990) {
        this.updateHeaderBottomPosition();
      }
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
